import { render, staticRenderFns } from "./DocumentSplitterSavePanel.vue?vue&type=template&id=2f518152&"
import script from "./DocumentSplitterSavePanel.vue?vue&type=script&lang=js&"
export * from "./DocumentSplitterSavePanel.vue?vue&type=script&lang=js&"
import style0 from "./DocumentSplitterSavePanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports